webpackJsonp([0],{

/***/ "+oBC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/KYC-Upload.694a173.png";

/***/ }),

/***/ "1/oy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Fvs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/EWallet-Funding.eb161f7.png";

/***/ }),

/***/ "35EX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diy-power.73115b3.png";

/***/ }),

/***/ "4au/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5bzC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.8dae916.png";

/***/ }),

/***/ "5eI7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Dashboard.3211aa9.png";

/***/ }),

/***/ "5mhT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/EWallet-BuyPackage.d3bb455.png";

/***/ }),

/***/ "7ZvQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nals-1.d51a6bb.jpg";

/***/ }),

/***/ "9kuL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Registration-Step2.4340f08.png";

/***/ }),

/***/ "A54u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/caren-dribbble.06dda32.gif";

/***/ }),

/***/ "BSzm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diy-tool-d.60f111d.gif";

/***/ }),

/***/ "Cagy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/morning.2665d77.png";

/***/ }),

/***/ "D2LR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nals-app-icon.47cfe7f.jpg";

/***/ }),

/***/ "GfHa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Id91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IyYQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/evening.df5df06.png";

/***/ }),

/***/ "MinI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diy-restart.26e0394.png";

/***/ }),

/***/ "MoFL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diy-backup.ab65bc7.png";

/***/ }),

/***/ "N1kN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//

/* harmony default export */ var App = ({
  name: 'App'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cbb314a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("4au/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/_header.js
var $ = void 0;
var tag = void 0;

/* harmony default export */ var _header = ({
  name: 'fixed-header',

  props: {
    threshold: {
      type: Number,
      default: 0,
      required: false
    }
  },

  mounted: function mounted() {
    $ = function $(e) {
      return document.querySelector(e);
    };
    tag = !window.chrome && 'WebkitAppearance' in document.documentElement.style ? 'body' : 'html';
    this.main();
  },


  methods: {
    main: function main() {
      var _this = this;

      this.check = function () {
        _this.$emit('update:fixed', $(tag).scrollTop > _this.threshold);
      };
      window.addEventListener('scroll', this.check);
    }
  },

  beforeDestory: function beforeDestory() {
    window.removeEventListener('scroll', this.check);
  },
  render: function render(h) {
    var children = this.$slots.default;
    return children[0];
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Header = ({
  name: 'header',
  components: {
    FixedHeader: _header
  },
  data: function data() {
    return {
      isFixed: false,
      expand: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a25c3e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
var Header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fixed-header',{attrs:{"fixed":_vm.isFixed},on:{"update:fixed":function($event){_vm.isFixed=$event}}},[_c('header',{staticClass:"header",class:{ 'scrolled': _vm.isFixed, 'responsive': _vm.expand }},[_c('b-container',[_c('b-row',{staticClass:"header-content"},[_c('div',{staticClass:"brand"},[_c('b-link',{attrs:{"to":"/","exact":""}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("ZBbY"),"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"toggle",class:{ 'open': _vm.expand },on:{"click":function($event){_vm.expand = !_vm.expand}}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"container_top-nav"},[_c('ul',{staticClass:"top-nav float-right"},[_c('li',[_c('b-link',{attrs:{"to":{ path: '/' },"exact":""},on:{"click":function($event){_vm.expand = !_vm.expand}}},[_vm._v("Work")])],1),_vm._v(" "),_c('li',[_c('b-link',{attrs:{"to":{ path: '/about' },"exact":""},on:{"click":function($event){_vm.expand = !_vm.expand}}},[_vm._v("About")])],1),_vm._v(" "),_c('li',[_c('b-link',{attrs:{"href":"https://dribbble.com/ronnelsanchez"}},[_vm._v("Dribbble")])],1),_vm._v(" "),_c('li',[_c('b-link',{attrs:{"href":"https://www.behance.net/ronnelsanchez"}},[_vm._v("Behance")])],1),_vm._v(" "),_c('li',[_c('b-link',{attrs:{"href":"https://ph.linkedin.com/in/ronnelsanchez"}},[_vm._v("Linkedin")])],1),_vm._v(" "),_c('li',[_c('b-link',{attrs:{"to":{ path: '/contact' },"exact":""},on:{"click":function($event){_vm.expand = !_vm.expand}}},[_vm._v("Contact")])],1)])])])],1)],1)])}
var Header_staticRenderFns = []
var Header_esExports = { render: Header_render, staticRenderFns: Header_staticRenderFns }
/* harmony default export */ var components_Header = (Header_esExports);
// CONCATENATED MODULE: ./src/components/Header.vue
var Header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Header___vue_template_functional__ = false
/* styles */
var Header___vue_styles__ = null
/* scopeId */
var Header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Header___vue_module_identifier__ = null
var Header_Component = Header_normalizeComponent(
  Header,
  components_Header,
  Header___vue_template_functional__,
  Header___vue_styles__,
  Header___vue_scopeId__,
  Header___vue_module_identifier__
)

/* harmony default export */ var src_components_Header = (Header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Footer.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Footer = ({
  name: 'Footer'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aac0dc74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
var Footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('b-container',[_c('b-row',[_c('b-col',[_c('span',[_vm._v("© 2018. Design and develope by Ronnel Sanchez")])])],1)],1)],1)}
var Footer_staticRenderFns = []
var Footer_esExports = { render: Footer_render, staticRenderFns: Footer_staticRenderFns }
/* harmony default export */ var components_Footer = (Footer_esExports);
// CONCATENATED MODULE: ./src/components/Footer.vue
var Footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Footer___vue_template_functional__ = false
/* styles */
var Footer___vue_styles__ = null
/* scopeId */
var Footer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Footer___vue_module_identifier__ = null
var Footer_Component = Footer_normalizeComponent(
  Footer,
  components_Footer,
  Footer___vue_template_functional__,
  Footer___vue_styles__,
  Footer___vue_scopeId__,
  Footer___vue_module_identifier__
)

/* harmony default export */ var src_components_Footer = (Footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/container/Main.vue
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Main = ({
  name: 'Main',
  components: {
    Header: src_components_Header,
    Footer: src_components_Footer
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e4bd48d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/container/Main.vue
var Main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Header'),_vm._v(" "),_c('main',[_c('b-container',[_c('router-view')],1)],1),_vm._v(" "),_c('Footer')],1)}
var Main_staticRenderFns = []
var Main_esExports = { render: Main_render, staticRenderFns: Main_staticRenderFns }
/* harmony default export */ var container_Main = (Main_esExports);
// CONCATENATED MODULE: ./src/container/Main.vue
var Main_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Main___vue_template_functional__ = false
/* styles */
var Main___vue_styles__ = null
/* scopeId */
var Main___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Main___vue_module_identifier__ = null
var Main_Component = Main_normalizeComponent(
  Main,
  container_Main,
  Main___vue_template_functional__,
  Main___vue_styles__,
  Main___vue_scopeId__,
  Main___vue_module_identifier__
)

/* harmony default export */ var src_container_Main = (Main_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Welcome.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Welcome = ({
  name: 'Welcome'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-457606c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
var Welcome_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Welcome_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container_welcome"},[_c('div',{staticClass:"welcome_content"},[_c('h1',[_vm._v("Hello, I'm Ronnel Sanchez.")]),_vm._v(" "),_c('h2',[_vm._v("UI/UX Designer and Front-End Developer.")])])])}]
var Welcome_esExports = { render: Welcome_render, staticRenderFns: Welcome_staticRenderFns }
/* harmony default export */ var components_Welcome = (Welcome_esExports);
// CONCATENATED MODULE: ./src/components/Welcome.vue
var Welcome_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Welcome___vue_template_functional__ = false
/* styles */
var Welcome___vue_styles__ = null
/* scopeId */
var Welcome___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Welcome___vue_module_identifier__ = null
var Welcome_Component = Welcome_normalizeComponent(
  Welcome,
  components_Welcome,
  Welcome___vue_template_functional__,
  Welcome___vue_styles__,
  Welcome___vue_scopeId__,
  Welcome___vue_module_identifier__
)

/* harmony default export */ var src_components_Welcome = (Welcome_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Work.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Work = ({
  name: 'Work',
  components: {
    Welcome: src_components_Welcome
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d09e127","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Work.vue
var Work_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"work"},[_c('Welcome'),_vm._v(" "),_c('b-row',[_c('router-link',{staticClass:"col-12 col-md-6 portfolio-item",attrs:{"to":"/backoffice","tag":"div"}},[_c('img',{attrs:{"src":__webpack_require__("5bzC"),"alt":""}}),_vm._v(" "),_c('h4',[_vm._v("Ducatus crypto platform")]),_vm._v(" "),_c('p',[_vm._v("Crypto platform with trading, wallet and network")]),_vm._v(" "),_c('ul',{staticClass:"tags"},[_c('li',[_vm._v("UI/UX")]),_vm._v(" "),_c('li',[_vm._v("Product Design")]),_vm._v(" "),_c('li',[_vm._v("Web Design")]),_vm._v(" "),_c('li',[_vm._v("Information Architecture")]),_vm._v(" "),_c('li',[_vm._v("Front-End")])])]),_vm._v(" "),_c('router-link',{staticClass:"col-12 col-md-6 portfolio-item",attrs:{"to":"/nals","tag":"div"}},[_c('img',{attrs:{"src":__webpack_require__("sFge"),"alt":""}}),_vm._v(" "),_c('h4',[_vm._v("NALS - Trend Micro's leave system app")]),_vm._v(" "),_c('p',[_vm._v("A mobile leave system app")]),_vm._v(" "),_c('ul',{staticClass:"tags"},[_c('li',[_vm._v("UI/UX")]),_vm._v(" "),_c('li',[_vm._v("Product Design")]),_vm._v(" "),_c('li',[_vm._v("App")]),_vm._v(" "),_c('li',[_vm._v("Illustration")]),_vm._v(" "),_c('li',[_vm._v("Information Architecture")])])]),_vm._v(" "),_c('router-link',{staticClass:"col-12 col-md-6 portfolio-item",attrs:{"to":"/timelog","tag":"div"}},[_c('img',{attrs:{"src":__webpack_require__("s3dv"),"alt":""}}),_vm._v(" "),_c('h4',[_vm._v("Timelog - Trend Micro PH office")]),_vm._v(" "),_c('p',[_vm._v("Redesigning the new Trend Micro Timelog")]),_vm._v(" "),_c('ul',{staticClass:"tags"},[_c('li',[_vm._v("UI/UX")]),_vm._v(" "),_c('li',[_vm._v("Front-End")]),_vm._v(" "),_c('li',[_vm._v("Illustration")]),_vm._v(" "),_c('li',[_vm._v("Web Design")])])]),_vm._v(" "),_c('router-link',{staticClass:"col-12 col-md-6 portfolio-item",attrs:{"to":"/reformat","tag":"div"}},[_c('img',{attrs:{"src":__webpack_require__("BSzm"),"alt":""}}),_vm._v(" "),_c('h4',[_vm._v("DIY Reformat Tool - Trend Micro PH")]),_vm._v(" "),_c('p',[_vm._v("Trend Micro's do it yourself reformating tool.")]),_vm._v(" "),_c('ul',{staticClass:"tags"},[_c('li',[_vm._v("UI/UX")]),_vm._v(" "),_c('li',[_vm._v("Product Design")]),_vm._v(" "),_c('li',[_vm._v("Illustration")]),_vm._v(" "),_c('li',[_vm._v("Information Architecture")])])]),_vm._v(" "),_c('b-col',{staticClass:"portfolio-item",attrs:{"cols":"12","md":"6"}},[_c('a',{attrs:{"href":"https://dribbble.com/ronnelsanchez"}},[_c('img',{attrs:{"src":__webpack_require__("m4uL"),"alt":""}})]),_vm._v(" "),_c('h4',[_vm._v("Icons, Logos and Illustrations")]),_vm._v(" "),_c('p',[_vm._v("Sets of icon, logos and illustration from various projects.")]),_vm._v(" "),_c('ul',{staticClass:"tags"},[_c('li',[_vm._v("Graphic Design")]),_vm._v(" "),_c('li',[_vm._v("Illustration")])])])],1)],1)}
var Work_staticRenderFns = []
var Work_esExports = { render: Work_render, staticRenderFns: Work_staticRenderFns }
/* harmony default export */ var views_Work = (Work_esExports);
// CONCATENATED MODULE: ./src/views/Work.vue
var Work_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Work___vue_template_functional__ = false
/* styles */
var Work___vue_styles__ = null
/* scopeId */
var Work___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Work___vue_module_identifier__ = null
var Work_Component = Work_normalizeComponent(
  Work,
  views_Work,
  Work___vue_template_functional__,
  Work___vue_styles__,
  Work___vue_scopeId__,
  Work___vue_module_identifier__
)

/* harmony default export */ var src_views_Work = (Work_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/About.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var About = ({
  name: 'About'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3009cd48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/About.vue
var About_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('section',{staticClass:"about-head"},[_c('b-row',[_c('b-col',{staticClass:"order-md-last",attrs:{"md":"5"}},[_c('img',{staticClass:"about-photo",attrs:{"src":__webpack_require__("TN3P"),"alt":""}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"7"}},[_c('h1',[_vm._v("\n          Hello, I'm Ronnel Sanchez.\n        ")]),_vm._v(" "),_c('p',[_vm._v("I am a UI/UX Designer and Front-End Developer. I have 6 years of UI/UX design experience and specialize in user-centered design, information architecture and prototyping.")]),_vm._v(" "),_c('p',[_vm._v("Having design and programing skill sets, I'm keen to connect People and Technology.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"btn btn-primary btn-lg btn-download",attrs:{"href":"/static/files/Ronnel_Sanchez-CV.pdf","target":"_blank"}},[_vm._v("\n          Download Resume\n        ")])])],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',{attrs:{"md":"7"}},[_c('h3',[_vm._v("Experiences")]),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-md-3"},[_c('small',{staticClass:"mb-3 content-date"},[_c('i',[_vm._v("Nov 2017 - Present")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"content-title"},[_vm._v("UI/UX Designer and Front-End Developer")]),_vm._v(" "),_c('div',{staticClass:"content-subtitle"},[_vm._v("Ducatus Global Singapore - Philippine Based")]),_vm._v(" "),_c('div',{staticClass:"content-body"},[_c('p',[_vm._v("Key designer for Ducatus Customer console site redesign.\tCreate user flow, wireframes, personas, storyboards, process flow, interaction design and information architecture.")])])])]),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-md-3"},[_c('small',{staticClass:"mb-3 content-date"},[_c('i',[_vm._v("Dec 2012 - Nov 2017")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"content-title"},[_vm._v("UI/UX Designer and Developer")]),_vm._v(" "),_c('div',{staticClass:"content-subtitle"},[_vm._v("Trend Micro - Philippines")]),_vm._v(" "),_c('div',{staticClass:"content-body"},[_c('p',[_vm._v("Deliver UI/UX design for internal and external Trendmicro user. Co-lead the Web development team from analysing business requirements, user research and conceptualizing information architecture.")])])])]),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-md-3"},[_c('small',{staticClass:"mb-3 content-date"},[_c('i',[_vm._v("Sept 2012 - Oct 2012")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"content-title"},[_vm._v("Graphical User Interface Designer")]),_vm._v(" "),_c('div',{staticClass:"content-subtitle"},[_vm._v("Job and Esther Technologies - Philippines")]),_vm._v(" "),_c('div',{staticClass:"content-body"},[_c('p',[_vm._v("Create graphical user interfaces (GUIs) for a variety of software products like mobile app, websit, desktop software, games app and enterprise applications.")])])])]),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-md-3"},[_c('small',{staticClass:"mb-3 content-date"},[_c('i',[_vm._v("Dec 2010 - Sept 2012")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"content-title"},[_vm._v("UI Developer")]),_vm._v(" "),_c('div',{staticClass:"content-subtitle"},[_vm._v("Coding Solution Information Technology - Philippines")]),_vm._v(" "),_c('div',{staticClass:"content-body"},[_c('p',[_vm._v("Key designer for CSIT projects: Web App, Window based applications and Saas.")])])])])],1)],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',{attrs:{"md":"7"}},[_c('h3',[_vm._v("Awards")]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"content-title"},[_vm._v("Special Award - \"Bravery\" 2017")]),_vm._v(" "),_c('div',{staticClass:"content-subtitle"},[_vm._v("Trend Micro Philippines")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"content-title"},[_vm._v("Employee of the Quarter (2H 2016)")]),_vm._v(" "),_c('div',{staticClass:"content-subtitle"},[_vm._v("Trend Micro Philippines")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"content-title"},[_vm._v("Employee of the Quarter (1H 2015)")]),_vm._v(" "),_c('div',{staticClass:"content-subtitle"},[_vm._v("Trend Micro Philippines")])])],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',{attrs:{"md":"7"}},[_c('h3',[_vm._v("Education")]),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-md-3"},[_c('small',{staticClass:"content-date"},[_c('i',[_vm._v("2008 - 2012")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"content-title"},[_vm._v("Bachelor of Science in Information Technology")]),_vm._v(" "),_c('div',{staticClass:"content-subtitle"},[_vm._v("AMA Computer University - Santa Cruz Laguna, Philippines")])])])],1)],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',{attrs:{"md":"7"}},[_c('h3',[_vm._v("Skills")]),_vm._v(" "),_c('ul',{staticClass:"list list-unstyled"},[_c('li',[_vm._v("UI/UX Design")]),_vm._v(" "),_c('li',[_vm._v("Wireframing")]),_vm._v(" "),_c('li',[_vm._v("Prototyping")]),_vm._v(" "),_c('li',[_vm._v("Front-End Development")]),_vm._v(" "),_c('li',[_vm._v("Visual Design")]),_vm._v(" "),_c('li',[_vm._v("Graphic Design")]),_vm._v(" "),_c('li',[_vm._v("Agile Methodology")])])])],1)],1)])}
var About_staticRenderFns = []
var About_esExports = { render: About_render, staticRenderFns: About_staticRenderFns }
/* harmony default export */ var views_About = (About_esExports);
// CONCATENATED MODULE: ./src/views/About.vue
var About_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var About___vue_template_functional__ = false
/* styles */
var About___vue_styles__ = null
/* scopeId */
var About___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var About___vue_module_identifier__ = null
var About_Component = About_normalizeComponent(
  About,
  views_About,
  About___vue_template_functional__,
  About___vue_styles__,
  About___vue_scopeId__,
  About___vue_module_identifier__
)

/* harmony default export */ var src_views_About = (About_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Contact.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Contact = ({
  name: 'About'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29133612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Contact.vue
var Contact_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('section',{staticClass:"contact-head"},[_c('b-row',[_c('b-col',{attrs:{"md":"7"}},[_c('h1',[_vm._v("\n        Contact me here\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"btn btn-primary btn-lg btn-mail mb-5",attrs:{"href":"mailto:ronnel.sanchez@gmail.com"}},[_vm._v("\n          ronnel.sanchez@gmail.com\n        ")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled list list-icon"},[_c('li',{staticClass:"icon-skype"},[_c('b',[_vm._v("Skype")]),_c('a',{attrs:{"href":"skype:ronnel.sanchez_1?chat"}},[_vm._v("ronnel.sanchez_1")])]),_vm._v(" "),_c('li',{staticClass:"icon-whatsapp"},[_c('b',[_vm._v("WhatsApp / Mobile")]),_c('a',{attrs:{"href":"https://api.whatsapp.com/send?phone=639272197146"}},[_vm._v("+63 927 219 7146")])]),_vm._v(" "),_c('li',{staticClass:"icon-telegram"},[_c('b',[_vm._v("Telegram")]),_c('a',{attrs:{"href":"https://telegram.me/ronnelsanchez"}},[_vm._v("@ronnelsanchez")])])])])],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',{attrs:{"md":"7"}},[_c('h3',[_vm._v("Portfolios")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled list list-icon"},[_c('li',{staticClass:"icon-dribbble"},[_c('b',[_vm._v("Dribbble")]),_c('a',{attrs:{"href":"https://dribbble.com/ronnelsanchez"}},[_vm._v("https://dribbble.com/ronnelsanchez")])]),_vm._v(" "),_c('li',{staticClass:"icon-behance"},[_c('b',[_vm._v("Behance")]),_c('a',{attrs:{"href":"https://www.behance.net/ronnelsanchez"}},[_vm._v("https://www.behance.net/ronnelsanchez")])])])])],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',{attrs:{"md":"7"}},[_c('h3',[_vm._v("Links")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled list list-icon"},[_c('li',{staticClass:"icon-linkedin"},[_c('b',[_vm._v("LinkedIn")]),_c('a',{attrs:{"href":"https://ph.linkedin.com/in/ronnelsanchez"}},[_vm._v("https://ph.linkedin.com/in/ronnelsanchez")])]),_vm._v(" "),_c('li',{staticClass:"icon-github"},[_c('b',[_vm._v("GitHub")]),_c('a',{attrs:{"href":"https://github.com/ronnelsanchez"}},[_vm._v("https://github.com/ronnelsanchez")])])])])],1)],1)])}
var Contact_staticRenderFns = []
var Contact_esExports = { render: Contact_render, staticRenderFns: Contact_staticRenderFns }
/* harmony default export */ var views_Contact = (Contact_esExports);
// CONCATENATED MODULE: ./src/views/Contact.vue
var Contact_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Contact___vue_template_functional__ = false
/* styles */
var Contact___vue_styles__ = null
/* scopeId */
var Contact___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Contact___vue_module_identifier__ = null
var Contact_Component = Contact_normalizeComponent(
  Contact,
  views_Contact,
  Contact___vue_template_functional__,
  Contact___vue_styles__,
  Contact___vue_scopeId__,
  Contact___vue_module_identifier__
)

/* harmony default export */ var src_views_Contact = (Contact_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Works/Nals.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Nals = ({
  name: 'Portfolio'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f937c3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Works/Nals.vue
var Nals_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio"},[_c('section',{staticClass:"portfolio-head"},[_c('b-row',[_c('b-col',{attrs:{"md":"8","offset-md":"2"}},[_c('img',{staticClass:"portfolio-icon",attrs:{"src":__webpack_require__("ZoeB"),"alt":""}}),_vm._v(" "),_c('h1',[_vm._v("\n          NALS - Trend Micro's leave system app\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          NALS or North America Leave System is an internal app of Trend Micro that helps employee to file a leave easily on their mobile device. It also have a monitoring list to track their filed leave if its approved or not.\n        ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("gNdR"),"alt":""}})])],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',[_c('h3',[_vm._v("About the project")]),_vm._v(" "),_c('p',[_vm._v("In Trend Micro employee’s safety, health and family are important to the company’s culture that whenever an employee needs time for there family or personal agenda Trend Micro’s allow them to take some leaves. But with the previous system there are always a delay when ever an employee’s file a leave of absent to inform and be approved by there manager. Specially to those who work remotely like sales and marketing connecting to VPN just to file a leave is hideous")]),_vm._v(" "),_c('p',[_vm._v("My task is to design a new process that will make the filling of leave more accessible, easy and can be monitor both the employee and their manager.")])])],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',[_c('h3',[_vm._v("Solution")]),_vm._v(" "),_c('p',[_vm._v("As I employee of Trend Micro who also file leave I know how hard the process just to file and inform my manager. Since majority of leave are filed remotely we need to create a mobile app that employees can be access even without VPN and have simplified process.")]),_vm._v(" "),_c('p',[_vm._v("The process will like just sending a message to the manager and rather than using the old forms employee just need to fill out the Date and the Reason of leave which make it more personal.")]),_vm._v(" "),_c('p',[_vm._v("The app also shows the status of the leave and integrated with the employee’s team it has a calendar that shows their team members leave to help them plan ahead if needed.")])])],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',[_c('h3',[_vm._v("Features")]),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("7ZvQ"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("Q270"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("UQuz"),"alt":""}})])],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',[_c('h3',[_vm._v("Visual Design")]),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("A54u"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("PWqq"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("D2LR"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("qISU"),"alt":""}})])],1)],1),_vm._v(" "),_c('section',{staticClass:"portfolio-referrence"},[_c('b-row',[_c('b-col',[_c('div',[_c('span',{staticClass:"label"},[_vm._v("Links")]),_c('br'),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("\n              NALS iOS: "),_c('a',{attrs:{"href":"https://invis.io/9Y2ZELQE6"}},[_vm._v("https://invis.io/9Y2ZELQE6")])]),_vm._v(" "),_c('li',[_vm._v("\n              NALS Android: "),_c('a',{attrs:{"href":"https://invis.io/9H2ZDWZJP"}},[_vm._v("https://invis.io/9H2ZDWZJP")])])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"label"},[_vm._v("Tool Used")]),_vm._v(" "),_c('ul',{staticClass:"tools"},[_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-photoshop-plain",attrs:{"title":"Adobe Photoshop"}})]),_vm._v(" "),_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-illustrator-plain",attrs:{"title":"Adobe Illustrator"}})]),_vm._v(" "),_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-android-plain",attrs:{"title":"Android Material Design Guidelines"}})]),_vm._v(" "),_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-apple-plain",attrs:{"title":"iOS Human Interface Guidelines"}})])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"label"},[_vm._v("Category")]),_vm._v(" "),_c('ul',{staticClass:"tags"},[_c('li',[_vm._v("UI/UX")]),_vm._v(" "),_c('li',[_vm._v("Product Design")]),_vm._v(" "),_c('li',[_vm._v("Illustration")]),_vm._v(" "),_c('li',[_vm._v("Information Architecture")])])])])],1)],1),_vm._v(" "),_c('section',{staticClass:"portfolio-bottom"},[_c('b-row',[_c('b-col',[_c('b-link',{attrs:{"to":"/"}},[_vm._v("\n          View more project\n        ")])],1)],1)],1)])}
var Nals_staticRenderFns = []
var Nals_esExports = { render: Nals_render, staticRenderFns: Nals_staticRenderFns }
/* harmony default export */ var Works_Nals = (Nals_esExports);
// CONCATENATED MODULE: ./src/views/Works/Nals.vue
var Nals_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Nals___vue_template_functional__ = false
/* styles */
var Nals___vue_styles__ = null
/* scopeId */
var Nals___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Nals___vue_module_identifier__ = null
var Nals_Component = Nals_normalizeComponent(
  Nals,
  Works_Nals,
  Nals___vue_template_functional__,
  Nals___vue_styles__,
  Nals___vue_scopeId__,
  Nals___vue_module_identifier__
)

/* harmony default export */ var views_Works_Nals = (Nals_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Works/Timelog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Timelog = ({
  name: 'Portfolio'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cacb1b20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Works/Timelog.vue
var Timelog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio"},[_c('section',{staticClass:"portfolio-head"},[_c('b-row',[_c('b-col',{attrs:{"md":"8","offset-md":"2"}},[_c('img',{staticClass:"portfolio-icon",attrs:{"src":__webpack_require__("cMXz"),"alt":""}}),_vm._v(" "),_c('h1',[_vm._v("\n          Timelog - Trend Micro PH\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Redesign Trend Micro timelog with dynamic background that change depending on time.\n        ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("s3dv"),"alt":""}})])],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',[_c('h3',[_vm._v("About the project")]),_vm._v(" "),_c('p',[_vm._v("I been task to redesign and change the overall user experience of Trend Micro PH timelog. I design it more simpler, easy to use and a portal that can be set as a browser home screen.")]),_vm._v(" "),_c('p',[_vm._v("The one with batman at the back is my cube.😁")])])],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('span',[_vm._v("Morning")]),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("Cagy"),"alt":""}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('span',[_vm._v("Afternoon")]),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("ScoF"),"alt":""}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('span',[_vm._v("Evening")]),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("IyYQ"),"alt":""}})])],1)],1),_vm._v(" "),_c('section',{staticClass:"portfolio-referrence"},[_c('b-row',[_c('b-col',[_c('div',[_c('span',{staticClass:"label"},[_vm._v("Links")]),_c('br'),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("\n              Dribbble "),_c('a',{attrs:{"href":"https://dribbble.com/shots/3840460-Timelog-Trend-Micro-PH-office-time-log"}},[_vm._v("https://dribbble.com/shots/3840460-Timelog-Trend-Micro-PH-office-time-log")])])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"label"},[_vm._v("Tool Used")]),_vm._v(" "),_c('ul',{staticClass:"tools"},[_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-photoshop-plain",attrs:{"title":"Adobe Photoshop"}})]),_vm._v(" "),_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-illustrator-plain",attrs:{"title":"Adobe Illustrator"}})]),_vm._v(" "),_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-html5-plain-wordmark",attrs:{"title":"HTML 5"}})]),_vm._v(" "),_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-css3-plain-wordmark",attrs:{"title":"CSS 3"}})])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"label"},[_vm._v("Category")]),_vm._v(" "),_c('ul',{staticClass:"tags"},[_c('li',[_vm._v("UI/UX")]),_vm._v(" "),_c('li',[_vm._v("Front-End")]),_vm._v(" "),_c('li',[_vm._v("Illustration")]),_vm._v(" "),_c('li',[_vm._v("Web Design")])])])])],1)],1),_vm._v(" "),_c('section',{staticClass:"portfolio-bottom"},[_c('b-row',[_c('b-col',[_c('b-link',{attrs:{"to":"/"}},[_vm._v("\n          View more project\n        ")])],1)],1)],1)])}
var Timelog_staticRenderFns = []
var Timelog_esExports = { render: Timelog_render, staticRenderFns: Timelog_staticRenderFns }
/* harmony default export */ var Works_Timelog = (Timelog_esExports);
// CONCATENATED MODULE: ./src/views/Works/Timelog.vue
var Timelog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Timelog___vue_template_functional__ = false
/* styles */
var Timelog___vue_styles__ = null
/* scopeId */
var Timelog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Timelog___vue_module_identifier__ = null
var Timelog_Component = Timelog_normalizeComponent(
  Timelog,
  Works_Timelog,
  Timelog___vue_template_functional__,
  Timelog___vue_styles__,
  Timelog___vue_scopeId__,
  Timelog___vue_module_identifier__
)

/* harmony default export */ var views_Works_Timelog = (Timelog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Works/Reformat.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Reformat = ({
  name: 'Portfolio'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26ee16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Works/Reformat.vue
var Reformat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio"},[_c('section',{staticClass:"portfolio-head"},[_c('b-row',[_c('b-col',{attrs:{"md":"8","offset-md":"2"}},[_c('img',{staticClass:"portfolio-icon",attrs:{"src":__webpack_require__("ulWi"),"alt":""}}),_vm._v(" "),_c('h1',[_vm._v("\n          DIY Reformat Tool - Trend Micro PH\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Trend Micro's "),_c('i',[_vm._v("do it yourself")]),_vm._v(" reformating tool.\n        ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("BSzm"),"alt":""}})])],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',[_c('h3',[_vm._v("About the project")]),_vm._v(" "),_c('p',[_vm._v("This project I work on is to solve the problem for IT engineers and Employee of Trend Micro to fasten the reformating process but assuring the steps are simplified and easy to understand.")]),_vm._v(" "),_c('p',[_vm._v("I did the overall user and system research also information architecture, visual design and illustration.")])])],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',[_c('h3',[_vm._v("Problems")]),_vm._v(" "),_c('p',[_vm._v("Simplifing a critical task like Reformating a computer is really a challenge. I need to consider this things:")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b',[_vm._v("Not all user knows how to format")]),_vm._v(" "),_c('p',[_vm._v("Though we are a tech company, we still have different skill sets which not include troubleshooting computer problems")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b',[_vm._v("User available time")]),_vm._v(" "),_c('p',[_vm._v("As an agile company we need to make things fast. The solution should be easy and fast with no need to learn new things to accomplish the task.")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b',[_vm._v("System Requirements")]),_vm._v(" "),_c('p',[_vm._v("Reformating needs to follow certain steps one at a time. Skipping on steps will lead to permanent issue to a computer.")])])],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',[_c('h3',[_vm._v("Solutions")]),_vm._v(" "),_c('p',[_vm._v("Considering the User and Technology is a must. Making sure that the user can easly follow the instruction and yet without the need to have a skill to do the task.")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b',[_vm._v("Make the instruction clear")]),_vm._v(" "),_c('p',[_vm._v("I added illustration to show the user what needed to be done. Also making the wordings less "),_c('i',[_vm._v("system language")]),_vm._v(".")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b',[_vm._v("Lessen the steps")]),_vm._v(" "),_c('p',[_vm._v("Working with the IT team. We manage to lessen the steps from 15 to 6 making it more easy for the user to follow and less stressfull.")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b',[_vm._v("Progress and Status")]),_vm._v(" "),_c('p',[_vm._v("Apart form showing some illustration, Displaying the status and progress makes the user feel more engage lessen the rate missing some steps.")])])],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',[_c('h3',[_vm._v("Visual Design")]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"mb clickable",attrs:{"src":__webpack_require__("jBJz"),"alt":""}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("Ou3t"),"alt":""}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("MoFL"),"alt":""}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("hzA0"),"alt":""}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("nppn"),"alt":""}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("35EX"),"alt":""}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("MinI"),"alt":""}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("lEnJ"),"alt":""}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("YdQc"),"alt":""}})])],1)],1)],1)],1),_vm._v(" "),_c('section',{staticClass:"portfolio-referrence"},[_c('b-row',[_c('b-col',[_c('div',[_c('span',{staticClass:"label"},[_vm._v("Links")]),_c('br'),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("\n              Dribbble "),_c('a',{attrs:{"href":"https://dribbble.com/shots/3954976-DIY-Reformat-Tool-Steps"}},[_vm._v("https://dribbble.com/shots/3954976-DIY-Reformat-Tool-Steps")])])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"label"},[_vm._v("Tool Used")]),_vm._v(" "),_c('ul',{staticClass:"tools"},[_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-photoshop-plain",attrs:{"title":"Adobe Photoshop"}})]),_vm._v(" "),_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-illustrator-plain",attrs:{"title":"Adobe Illustrator"}})])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"label"},[_vm._v("Category")]),_vm._v(" "),_c('ul',{staticClass:"tags"},[_c('li',[_vm._v("UI/UX")]),_vm._v(" "),_c('li',[_vm._v("Product Design")]),_vm._v(" "),_c('li',[_vm._v("Illustration")]),_vm._v(" "),_c('li',[_vm._v("Information Architecture")])])])])],1)],1),_vm._v(" "),_c('section',{staticClass:"portfolio-bottom"},[_c('b-row',[_c('b-col',[_c('b-link',{attrs:{"to":"/"}},[_vm._v("\n          View more project\n        ")])],1)],1)],1)])}
var Reformat_staticRenderFns = []
var Reformat_esExports = { render: Reformat_render, staticRenderFns: Reformat_staticRenderFns }
/* harmony default export */ var Works_Reformat = (Reformat_esExports);
// CONCATENATED MODULE: ./src/views/Works/Reformat.vue
var Reformat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Reformat___vue_template_functional__ = false
/* styles */
var Reformat___vue_styles__ = null
/* scopeId */
var Reformat___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Reformat___vue_module_identifier__ = null
var Reformat_Component = Reformat_normalizeComponent(
  Reformat,
  Works_Reformat,
  Reformat___vue_template_functional__,
  Reformat___vue_styles__,
  Reformat___vue_scopeId__,
  Reformat___vue_module_identifier__
)

/* harmony default export */ var views_Works_Reformat = (Reformat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Works/Backoffice.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Backoffice = ({
  name: 'Backoffice'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e7b893a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Works/Backoffice.vue
var Backoffice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio"},[_c('section',{staticClass:"portfolio-head"},[_c('b-row',[_c('b-col',{attrs:{"md":"8","offset-md":"2"}},[_c('img',{staticClass:"portfolio-icon",attrs:{"src":__webpack_require__("olyG"),"alt":""}}),_vm._v(" "),_c('h1',[_vm._v("\n          Backoffice - Ducatus Global\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Redesign Ducatus Global Cryto platform from ground up. Improve user exprience from Login to Tranding.\n        ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"clickable",attrs:{"src":__webpack_require__("5bzC"),"alt":""}})])],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',[_c('h3',[_vm._v("About the project")]),_vm._v(" "),_c('p',[_vm._v("Ducatus has given me the privillage to take this challenge to redesign and improve the user experience of their crypto platform. Completely revamp from ground up. Ducatus Backoffice has micro-services like Crypt Trading, E-Wallet, KYC "),_c('i',[_vm._v("Know Your Customer")]),_vm._v(" and alot of third party payment gateway that i need to improve too.")]),_vm._v(" "),_c('p',[_vm._v("Apart form designing the new information architecture of the site, i also created the components of every modules needed using Vue.js.")])])],1)],1),_vm._v(" "),_c('section',[_c('b-row',[_c('b-col',[_c('h3',[_vm._v("Features")]),_vm._v(" "),_c('p',[_vm._v("Here are some of the micro-services inside Ducatus Backoffice")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-5"},[_c('b-col',{attrs:{"md":"6","offset-md":"3"}},[_c('span',[_vm._v("Dashboard")]),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"img-thumbnail clickable",attrs:{"src":__webpack_require__("5eI7"),"alt":""},on:{"click":function($event){_vm.open($event)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-5",attrs:{"md":"6"}},[_c('span',[_vm._v("Registration")]),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"img-thumbnail clickable",attrs:{"src":__webpack_require__("9kuL"),"alt":""}})]),_vm._v(" "),_c('b-col',{staticClass:"mb-5",attrs:{"md":"6"}},[_c('span',[_vm._v("KYC")]),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"img-thumbnail clickable",attrs:{"src":__webpack_require__("+oBC"),"alt":""}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-5",attrs:{"md":"6"}},[_c('span',[_vm._v("Network Tree")]),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"img-thumbnail clickable",attrs:{"src":__webpack_require__("wod2"),"alt":""}})]),_vm._v(" "),_c('b-col',{staticClass:"mb-5",attrs:{"md":"6"}},[_c('span',[_vm._v("Two Factor Authentication")]),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"img-thumbnail clickable",attrs:{"src":__webpack_require__("XFTY"),"alt":""}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-5",attrs:{"md":"6"}},[_c('span',[_vm._v("Crypto Wallet")]),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"img-thumbnail clickable",attrs:{"src":__webpack_require__("xek8"),"alt":""}})]),_vm._v(" "),_c('b-col',{staticClass:"mb-5",attrs:{"md":"6"}},[_c('span',[_vm._v("Payment Gateway")]),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"img-thumbnail clickable",attrs:{"src":__webpack_require__("1Fvs"),"alt":""}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-5",attrs:{"md":"6"}},[_c('span',[_vm._v("Checkout")]),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"img-thumbnail clickable",attrs:{"src":__webpack_require__("5mhT"),"alt":""}})]),_vm._v(" "),_c('b-col',{staticClass:"mb-5",attrs:{"md":"6"}},[_c('span',[_vm._v("Cart")]),_vm._v(" "),_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"img-thumbnail clickable",attrs:{"src":__webpack_require__("uDjP"),"alt":""}})])],1)],1),_vm._v(" "),_c('section',{staticClass:"portfolio-referrence"},[_c('b-row',[_c('b-col',[_c('div',[_c('span',{staticClass:"label"},[_vm._v("Links")]),_c('br'),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("\n              Live View "),_c('a',{attrs:{"href":"https://network.ducatus.net"}},[_vm._v("https://network.ducatus.net")])])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"label"},[_vm._v("Tool Used")]),_vm._v(" "),_c('ul',{staticClass:"tools"},[_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-photoshop-plain",attrs:{"title":"Adobe Photoshop"}})]),_vm._v(" "),_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-illustrator-plain",attrs:{"title":"Adobe Illustrator"}})]),_vm._v(" "),_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-vuejs-plain-wordmark",attrs:{"title":"Vue.JS"}})]),_vm._v(" "),_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-html5-plain-wordmark",attrs:{"title":"HTML 5"}})]),_vm._v(" "),_c('li',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"devicon-css3-plain-wordmark",attrs:{"title":"CSS 3"}})])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"label"},[_vm._v("Category")]),_vm._v(" "),_c('ul',{staticClass:"tags"},[_c('li',[_vm._v("UI/UX")]),_vm._v(" "),_c('li',[_vm._v("Product Design")]),_vm._v(" "),_c('li',[_vm._v("Web Design")]),_vm._v(" "),_c('li',[_vm._v("Information Architecture")]),_vm._v(" "),_c('li',[_vm._v("Front-End")])])])])],1)],1),_vm._v(" "),_c('section',{staticClass:"portfolio-bottom"},[_c('b-row',[_c('b-col',[_c('b-link',{attrs:{"to":"/"}},[_vm._v("\n          View more project\n        ")])],1)],1)],1)])}
var Backoffice_staticRenderFns = []
var Backoffice_esExports = { render: Backoffice_render, staticRenderFns: Backoffice_staticRenderFns }
/* harmony default export */ var Works_Backoffice = (Backoffice_esExports);
// CONCATENATED MODULE: ./src/views/Works/Backoffice.vue
var Backoffice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Backoffice___vue_template_functional__ = false
/* styles */
var Backoffice___vue_styles__ = null
/* scopeId */
var Backoffice___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Backoffice___vue_module_identifier__ = null
var Backoffice_Component = Backoffice_normalizeComponent(
  Backoffice,
  Works_Backoffice,
  Backoffice___vue_template_functional__,
  Backoffice___vue_styles__,
  Backoffice___vue_scopeId__,
  Backoffice___vue_module_identifier__
)

/* harmony default export */ var views_Works_Backoffice = (Backoffice_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js












vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    redirect: {
      name: 'Work'
    },
    component: src_container_Main,
    children: [{
      path: '/',
      name: 'Work',
      component: src_views_Work
    }, {
      path: '/about',
      name: 'About',
      component: src_views_About
    }, {
      path: '/contact',
      name: 'Contact',
      component: src_views_Contact
    }, {
      path: '/Backoffice',
      name: 'Backoffice',
      component: views_Works_Backoffice
    }, {
      path: '/nals',
      name: 'NALS',
      component: views_Works_Nals
    }, {
      path: '/Timelog',
      name: 'Timelog',
      component: views_Works_Timelog
    }, {
      path: '/Reformat',
      name: 'Reformat',
      component: views_Works_Reformat
    }]
  }]
}));
// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/index.js + 162 modules
var es = __webpack_require__("e6fC");

// EXTERNAL MODULE: ./node_modules/font-awesome/css/font-awesome.min.css
var font_awesome_min = __webpack_require__("e0XP");
var font_awesome_min_default = /*#__PURE__*/__webpack_require__.n(font_awesome_min);

// EXTERNAL MODULE: ./node_modules/viewerjs/dist/viewer.css
var viewer = __webpack_require__("N1kN");
var viewer_default = /*#__PURE__*/__webpack_require__.n(viewer);

// EXTERNAL MODULE: ./node_modules/v-viewer/dist/v-viewer.js
var v_viewer = __webpack_require__("EAZf");
var v_viewer_default = /*#__PURE__*/__webpack_require__.n(v_viewer);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








vue_esm["a" /* default */].use(v_viewer_default.a);
vue_esm["a" /* default */].use(es["a" /* default */]);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "Ou3t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diy-auto.48ea0a5.png";

/***/ }),

/***/ "PWqq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/error_message.bcb5aea.gif";

/***/ }),

/***/ "Q270":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nals-2.98597ca.jpg";

/***/ }),

/***/ "ScoF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/afternoon.1d6b446.png";

/***/ }),

/***/ "TN3P":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/me.a046d78.png";

/***/ }),

/***/ "UQuz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nals-3.f6d613f.jpg";

/***/ }),

/***/ "XFTY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Security-2FA.fd52fec.png";

/***/ }),

/***/ "YdQc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diy-done.6fa6e88.png";

/***/ }),

/***/ "ZBbY":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNjAiIGhlaWdodD0iMzYwIiB2aWV3Qm94PSIwIDAgMzYwIDM2MCI+DQogIDxtZXRhZGF0YT48P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDIgNzkuMTYwOTI0LCAyMDE3LzA3LzEzLTAxOjA2OjM5ICAgICAgICAiPg0KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4NCiAgICAgIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiLz4NCiAgIDwvcmRmOlJERj4NCjwveDp4bXBtZXRhPg0KDQoNCg0KDQoNCg0KDQoNCg0KDQoNCg0KDQoNCg0KDQoNCg0KDQoNCg0KPD94cGFja2V0IGVuZD0idyI/PjwvbWV0YWRhdGE+DQo8ZGVmcz4NCiAgICA8c3R5bGU+DQogICAgICAuY2xzLTEgew0KICAgICAgICBmaWxsLXJ1bGU6IGV2ZW5vZGQ7DQogICAgICB9DQogICAgPC9zdHlsZT4NCiAgPC9kZWZzPg0KICA8cGF0aCBpZD0iU2hhcGVfMl9jb3B5IiBkYXRhLW5hbWU9IlNoYXBlIDIgY29weSIgY2xhc3M9ImNscy0xIiBkPSJNMjc1LjI3NCwyNzUuMjc0TDM2MCwzNjBIMTQzLjc2NkwxODAsMzIzLjkyMnYwLjFMMjE2LDI4OVYxOEwxODAsNTQsMzYsMTk4djU0TDE4MCwxMDhWMjY5Ljg5Mkw4OS4zNDcsMzYwSDM2TDE0NCwyNTJWMTk4TDAsMzQyVjE4MEwxNzkuMjA1LDBIMjE2QTE0NC4wMjQsMTQ0LjAyNCwwLDAsMSwyNzUuMjc0LDI3NS4yNzRaTTAsMEgxMjUuM0wwLDEyNlYwWiIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ "ZoeB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/NALS_android_splash.6626189.png";

/***/ }),

/***/ "cMXz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon.1d16cc9.png";

/***/ }),

/***/ "e0XP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gNdR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.4b01125.png";

/***/ }),

/***/ "hzA0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diy-computer-name.1a42042.png";

/***/ }),

/***/ "jBJz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diy-d.654a38f.png";

/***/ }),

/***/ "lEnJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diy-system.e41cd03.png";

/***/ }),

/***/ "m4uL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-thumb.3f98b80.png";

/***/ }),

/***/ "nppn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diy-lan.2b63c25.png";

/***/ }),

/***/ "olyG":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "qISU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nals-screens.285084f.jpg";

/***/ }),

/***/ "s3dv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/timelog.eb55fbd.gif";

/***/ }),

/***/ "sFge":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nals-thumb.ba98ce9.png";

/***/ }),

/***/ "uDjP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/BuyPackage-Cart.629124d.png";

/***/ }),

/***/ "ulWi":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "wod2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MyNetwork-Genealogy.7b2f94c.png";

/***/ }),

/***/ "xek8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/EWallet.d00586f.png";

/***/ }),

/***/ "zj2Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.59e5276cc39884e04882.js